export default __webpack_public_path__ + "images/dummy.15c053b.png";